<template>
    <div class="w-full">
      <div class="grid grid-cols-1 gap-4 mb-1">
        <XInput label="Name / ID" v-model="filters.campaign.value" />
        <!-- <Superselect
          title="Verticals"
          v-model="filters.verticals.value"
          :modifiers="filters.verticals.modifiers ?? {}"
          label="name"
          track-by="name"
          :query="TAGS_QUERY"
          :query-variables="{
            filters: {
              type: { value: ['vertical'] },
              name: {
                value: [
                  'casino',
                  'sports betting'
                ]
              }
            },
            first: 100
          }"
        ></Superselect> -->
        <!-- <Superselect
          title="Countries"
          v-model="filters.countries.value"
          track-by="code"
          label="label"
          :options="[]"
          :query="COUNTRIES_QUERY"
          :query-variables="{
            first: 300
          }"
        ></Superselect> -->
        <!-- <Superselect
          title="Offer Type"
          v-model="filters.offerType.value"
          :custom-label="capitalizeAllWords"
          :options="offerTypes"
          :multiple="false"
        ></Superselect> -->
        <Superselect
          title="Status"
          v-model="filters.status.value"
          :custom-label="capitalize"
          :options="statusOptions"
        ></Superselect>
        <!-- <Superselect
          title="Payout Type"
          v-model="filters.payoutType.value"
          :custom-label="capitalize"
          :options="payoutTypeOptions"
        ></Superselect> -->
        <!-- <Superselect
          title="Payout Type"
          v-model="filters.payoutConversionType.value"
          :modifiers="filters.payoutConversionType.modifiers"
          :multiple="true"
          track-by="id"
          label="label"
          :query="CONVERSION_TYPE_OPTIONS_QUERY"
          queryDefaultInputText=""
          :queryVariables="{
            filters: {
              // name: {
              //   value: ['{input}'],
              //   modifiers: { matchType: 'contains' }
              // },
              slug: {
                value: [
                  'first-time-deposit',
                  'qualified-first-time-deposit',
                  'registration'
                ]
              }
            },
            first: 25
          }"
          :query-result-function="
            data => {
              let options = data.conversionTypes.data.map(value => ({
                id: value.slug,
                label: value.name
              }))
              option = [{ id: null, label: 'Default' }, ...options]
              return option
            }
          "
        ></Superselect> -->
        <Superselect
          title="Allowed Traffic Types"
          v-model="filters.allowed.value"
          label="name"
          track-by="name"
          :query="TAGS_QUERY"
          :query-variables="{
            filters: {
              type: { value: ['trafficType'] }
            },
            first: 100
          }"
        ></Superselect>
        <!-- <Superselect
          title="Allowed OS Type"
          v-model="filters.campaignOS.value"
          label="name"
          track-by="name"
          :query="TAGS_QUERY"
          :query-variables="{
            filters: {
              type: { value: ['campaignOS'] }
            },
            first: 100
          }"
        ></Superselect> -->
        <!-- <Superselect
          title="Allowed Browser Type"
          v-model="filters.campaignBrowser.value"
          label="name"
          track-by="name"
          :query="TAGS_QUERY"
          :query-variables="{
            filters: {
              type: { value: ['campaignBrowser'] }
            },
            first: 100
          }"
        ></Superselect> -->
      </div>
    </div>
  </template>
  
  <script setup>
  import { computed } from 'vue'

  import Superselect from '@/components/common/Superselect.vue'

  import TAGS_QUERY from '@/graphql/Tag/TagsQuery.gql'
  import COUNTRIES_QUERY from '@/graphql/Country/CountriesQuery.gql'
  // import CONVERSION_TYPE_OPTIONS_QUERY from '@/graphql/ConversionType/ConversionTypeOptionsQuery.gql'
  
  import { useCampaignsStore } from '@/stores/campaigns.js'

  const campaignsStore = useCampaignsStore()
  
  const verticals = []
  const devices = ['Mobile', 'Desktop']
  const statusOptions = [
    'Subscribed',
    'Available',
    'Pending Approval',
    'Declined',
    'Unsubscribed'
  ]

  const payoutTypeOptions = [
    "CPL",
    "CPA",
    // "cpi",
    // "cps",
    // "cpc",
  ]
  
  const offerTypes = ['smart link', 'single offer']
  const restrictions = [
    'pops',
    'domains',
    'display',
    'interstitials',
    'search',
    'email',
    'social',
    'push',
    'sms',
    'native',
    'incent',
    'adult',
    'viral'
  ]
  const orderBy = {
    column: 'created_at',
    order: 'DESC',
    label: 'Newest'
  }
  const orderByOptions = [
    {
      label: 'Newest',
      column: 'created_at',
      order: 'DESC'
    },
    {
      label: 'Oldest',
      column: 'created_at',
      order: 'ASC'
    }
  ]
  
  const filters = computed(() => campaignsStore.filters)
  
  const capitalize = (value) => {
    let output = value.split('')
    output[0] = output[0].toUpperCase()
    return output.join('')
  }
  
  const capitalizeAllWords = (value) => {
    let output = []
    let words = value.split(' ')
    for (let word of words) {
      output.push(capitalize(word))
    }
    return output.join(' ')
  }
  </script>
  
  <style></style>